{
	"submitTitle": "Välj material",
	"summary": {
		"title": "Sammanfattning",
		"declarationTypeTitle": "Deklarationstyp",
		"projectReferenceTitle": "Projektreferens"
	},
	"content": {
		"selectTheDeclarationTypeSection": {
			"title": "Välj deklarationstyp",
			"customerProject": {
				"title": "Kundprojekt",
				"description": "Materialet användes för ett externt projekt. Nu behöver jag tillhandahålla en deklaration som beskriver koldioxidreduktionerna för min kund."
			},
			"internalProjectOrProduct": {
				"title": "Internt projekt / produkt",
				"description": "Materialet användes för ett internt projekt eller en produkt. Jag behöver skapa en deklaration för att anspråkta koldioxidreduktionerna för vår egen verksamhet."
			}
		},
		"addProjectReferenceSection": {
			"title": "Lägg till projektreferens",
			"subTitle": "Du behöver tilldela koldioxidreduktioner till en projektreferens som du vill skapa deklarationen för.",
			"projectReferencePlaceholder": "Projektreferens"
		},
		"selectProjectSection": {
			"title": "Välj ett projekt",
			"createNewProjectPlaceholder": "Skapa nytt projekt"
		}
	},
	"errorMessages": {
		"declarationTypeRequired": "Deklarationstyp krävs",
		"projectReferenceRequired": "Projektreferens krävs",
		"fetchProjectsError": "Det gick inte att hämta tidigare projekt"
	}
}
